import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5f240442&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5f240442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f240442",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ActivityCard: require('/workspace/components/ActivityCard.vue').default,PackageCard: require('/workspace/components/PackageCard.vue').default,PlaceCard: require('/workspace/components/PlaceCard.vue').default,ActivityBlog: require('/workspace/components/ActivityBlog/ActivityBlog.vue').default})
